var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-linkedin 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9154 1.91992H4.55544C3.23064 1.91992 2.15544 2.99512 2.15544 4.31992V19.6799C2.15544 21.0047 3.23064 22.0799 4.55544 22.0799H19.9154C21.2402 22.0799 22.3154 21.0047 22.3154 19.6799V4.31992C22.3154 2.99512 21.2402 1.91992 19.9154 1.91992ZM8.39544 9.59992V18.7199H5.51544V9.59992H8.39544ZM5.51544 6.94552C5.51544 6.27352 6.09144 5.75992 6.95544 5.75992C7.81944 5.75992 8.36184 6.27352 8.39544 6.94552C8.39544 7.61752 7.85784 8.15992 6.95544 8.15992C6.09144 8.15992 5.51544 7.61752 5.51544 6.94552ZM18.9554 18.7199H16.0754C16.0754 18.7199 16.0754 14.2751 16.0754 13.9199C16.0754 12.9599 15.5954 11.9999 14.3954 11.9807H14.357C13.1954 11.9807 12.7154 12.9695 12.7154 13.9199C12.7154 14.3567 12.7154 18.7199 12.7154 18.7199H9.83544V9.59992H12.7154V10.8287C12.7154 10.8287 13.6418 9.59992 15.5042 9.59992C17.4098 9.59992 18.9554 10.9103 18.9554 13.5647V18.7199Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinLogo);
export default __webpack_public_path__ + "static/media/linkedin-logo.9d6fc68d5f0ae326563b0e593cc508dd.svg";
export { ForwardRef as ReactComponent };